import { Component, Input, OnInit } from '@angular/core';
import { CompanyUser, PortalUser, PublicUser } from 'src/app/core/models/users-models';
import { putToClipboard } from 'src/app/core/utils/dom-utils';

@Component({
  selector: 'craft-user-info-dropdown',
  templateUrl: './craft-user-info-dropdown.component.html',
  styleUrls: ['./craft-user-info-dropdown.component.scss'],
  standalone: false,
})
export class CraftUserInfoDropdownComponent implements OnInit {
  @Input() public user?: CompanyUser | PortalUser | PublicUser | null;
  @Input() public disabled = false;

  constructor() {}

  public ngOnInit() {}

  public copyEmail(e?: MouseEvent) {
    if (e) {
      e.stopPropagation();
    }

    if (this.user?.email) {
      putToClipboard(this.user.email);
    }
  }
}
